import { createFileRoute } from '@tanstack/react-router'
import AdministrationMetadata from 'Administration/components/configuration/metadata/AdministrationMetadata'

import AdministrationPage from '../-administrationPage'
import { Guard, adminClaims } from '../-guard'

export const Route = createFileRoute('/administration/metadata')({
    component: () => (
        <Guard claims={adminClaims}>
            <AdministrationPage>
                <AdministrationMetadata />
            </AdministrationPage>
        </Guard>
    ),
})
